import * as React from "react";
import { Box, OutlinedInput, InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { platformFonts, platformSearchInputSx, usePlatformColors } from "../tickitPlatformTheme";

export function PlatformFilterChip({ label, active, onClick, badge }) {
  const colors = usePlatformColors();
  return (
    <Box
      component="button"
      type="button"
      onClick={onClick}
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 0.5,
        border: `1.5px solid ${active ? colors.brand : colors.border2}`,
        borderRadius: "10px",
        bgcolor: active ? colors.brandPale : colors.surface,
        color: active ? colors.brand : colors.text2,
        fontFamily: platformFonts.body,
        fontSize: "13px",
        fontWeight: 600,
        py: 1.125,
        px: 1.75,
        cursor: "pointer",
        transition: "all 0.2s",
        "&:hover": {
          borderColor: colors.brand,
          color: colors.brand,
        },
        "&:focus-visible": {
          outline: `2px solid ${colors.brand}`,
          outlineOffset: 2,
        },
      }}
    >
      {label}
      {badge != null && (
        <Box
          component="span"
          sx={{
            ml: 0.5,
            fontSize: "0.625rem",
            fontWeight: 700,
            bgcolor: colors.danger,
            color: "#fff",
            borderRadius: "20px",
            px: 0.75,
            py: 0.125,
          }}
        >
          {badge}
        </Box>
      )}
    </Box>
  );
}

export default function PlatformSearchBar({ value, onChange, onKeyPress, placeholder, endAdornment }) {
  return (
    <Box sx={{ flex: 1, position: "relative" }}>
      <OutlinedInput
        fullWidth
        value={value}
        onChange={onChange}
        onKeyPress={onKeyPress}
        placeholder={placeholder}
        endAdornment={endAdornment}
        startAdornment={
          <InputAdornment position="start">
            <SearchIcon sx={{ color: "var(--platform-text-3)", fontSize: 18 }} />
          </InputAdornment>
        }
        sx={{ ...platformSearchInputSx }}
      />
    </Box>
  );
}
